<template>
    <v-row>
        <v-col md="12" class="text-center mt-5" v-if="registrationObj.step == 1">
          <img
            :src="url_image_processed"
            style="max-width:250px; width: calc(100% - 2rem); margin: 0 1rem;"
            ref="imgTop"
          />
          <h1 style="font-weight:300" class="mb0 text-h5 text-sm-h4">{{ title }}</h1>
        </v-col>
        <v-col 
          class="text-center" 
          v-if="registrationObj && registrationObj.promoterSel && registrationObj.step == 2" 
          style="margin-top: 10px;"
        >
          <h3>{{ promoterName }}</h3>
          <ImageCard 
            :src="`${urlDomain}${registrationObj.promoterSel.promoterLinkImage}`" 
            :urlImage="registrationObj.promoterSel.promoterLinkImage"
            height="80" typeComponent="Single" 
            @error="loadPlaceholder"
          />
        </v-col>
        <v-col 
          md="12" 
          v-if="registrationObj && registrationObj.eventSel && registrationObj.step > 2"
        >
          <v-row class="mt-2 ml-6 mr-6" no-gutters>
            <v-col cols="12" md="2" sm="4" class="mt-0 col_img_event_2">
              <ImageCard 
                :src="`${urlDomain}/${registrationObj.eventSel.eventImage}`" 
                :urlImage="registrationObj.eventSel.eventImage"
                class="img_card_event my-2 mx-auto" 
              />
            </v-col>
            <v-col class="mt-0 ml-4" md="8">
              <v-row>
                <v-col cols="12" md="8" class="pb-0">
                  <v-text-field outlined disabled :value="registrationObj.eventSel.eventName" :label="$t('registerEvent.event_name')" class="input_str_2 input_str_3" dense></v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="pt-1 pb-0">
                </v-col>
                <v-col cols="12" md="3" class="pt-1 pb-0">
                  <v-text-field 
                    outlined 
                    disabled 
                    :value="registrationObj.eventSel.eventDate|formatDateForHumans(false)" 
                    :label="$t('registerEvent.event_date')" 
                    class="input_str_2" 
                    dense 
                    persistent-hint
                  ></v-text-field>
                </v-col>
                 <v-col cols="12" md="2" sm="6" class="pl-3 pl-sm-0 pb-0 pt-1" v-if="registrationObj.eventSel.showTotalRegistered == 1">
                  <v-text-field outlined disabled :value="registrationObj.eventSel.totalReg" :label="$t('registerEvent.total_reg')" class="input_str_2 input_str_3" dense></v-text-field>
                </v-col>
                <v-col cols="12" md="2" sm="6" class="pl-3 pl-sm-0 pb-0 pt-1" v-if="registrationObj.eventSel.showTotalRegistered == 1 || registrationObj.eventSel.showTotalRegistered == 2">
                  <v-text-field outlined disabled :value="registrationObj.eventSel.leftOpen" :label="$t('registerEvent.open_left')" class="input_str_2"></v-text-field>
                </v-col>
                <v-col sm="6" class="timer_column_tablet pl-3 pb-0 pl-md-3 pt-1 pb-md-1">
                  <Timer
                    :stylec="1" 
                    v-if="registrationObj.eventSel.type == 'now'"
                    :starttime="registrationObj.eventSel.nowDate" 
                    :endtime="registrationObj.eventSel.regClose"
                    :labeltime="$t('registerEvent.open_left_time')" 
                    :classh="1"
                    @changeType="changeType"
                  ></Timer>
                  <Timer
                    :stylec="1" 
                    v-if="registrationObj.eventSel.type == 'soon'" 
                    :starttime="registrationObj.eventSel.nowDate"
                    :endtime="registrationObj.eventSel.regOpen" 
                    :labeltime="$t('registerEvent.opens_in')"
                    :classh="0" 
                    @changeType="changeType"
                  ></Timer>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4" sm="6" class="pt-1 pb-0">
                  <v-text-field 
                    outlined disabled 
                    :value="registrationObj.eventSel.registrationOpen|formatDateForHumans()" 
                    :label="$t('registerEvent.open_reg')" 
                    class="input_str_2" 
                    persistent-hint
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" sm="6" class="pl-3 pl-sm-0 pt-1 pb-0">
                  <v-text-field 
                    outlined disabled 
                    :value="registrationObj.eventSel.registrationClose|formatDateForHumans()" 
                    :label="$t('registerEvent.close_reg')" 
                    class="input_str_2" 
                    persistent-hint
                  ></v-text-field>
                </v-col>
                <v-col col="12" md="4" sm="6" class="timer_column pl-3 pl-sm-0 pb-0 pt-1">
                  <Timer
                    :stylec="1" 
                    v-if="registrationObj.eventSel.type == 'now'" 
                    :starttime="registrationObj.eventSel.nowDate"
                    :endtime="registrationObj.eventSel.regClose" 
                    :labeltime="$t('registerEvent.open_left_time')"
                    :classh="1" 
                    @changeType="changeType"
                  ></Timer>
                  <Timer
                    :stylec="1" 
                    v-if="registrationObj.eventSel.type == 'soon'"
                    :starttime="registrationObj.eventSel.nowDate" 
                    :endtime="registrationObj.eventSel.regOpen"
                    :labeltime="$t('registerEvent.opens_in')" 
                    :classh="0"
                    @changeType="changeType"
                  ></Timer>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4" sm="6" class="pt-1 pb-0">
                  <v-text-field 
                    outlined disabled 
                    :value="registrationObj.eventSel.city" 
                    :label="$t('registerEvent.city')" 
                    class="input_str_2 input_str_3" 
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" sm="6" class="pl-3 pl-sm-0 pb-0 pt-1">
                  <v-text-field 
                    outlined disabled 
                    :value="registrationObj.eventSel.eventCountry" 
                    :label="$t('registerEvent.country')" 
                    class="input_str_2"
                  ></v-text-field>
                </v-col>
                <v-col md="3" class="hidden_sm_event pl-0 pt-1" style="position:relative;">
                  <Timer
                    :stylec="1" 
                    v-if="registrationObj.eventSel.type == 'now'"
                    :starttime="registrationObj.eventSel.nowDate" 
                    :endtime="registrationObj.eventSel.regClose"
                    :labeltime="$t('registerEvent.open_left_time')" 
                    :classh="1"
                    @changeType="changeType"
                  ></Timer>
                  <Timer
                    :stylec="1" 
                    v-if="registrationObj.eventSel.type == 'soon'"
                    :starttime="registrationObj.eventSel.nowDate" 
                    :endtime="registrationObj.eventSel.regOpen"
                    :labeltime="$t('registerEvent.opens_in')" 
                    :classh="0"
                    @changeType="changeType"
                  ></Timer>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
</template>

<script>
import { VRow, VCol, VTextField } from 'vuetify/lib';
import Timer from "@/components/timer/Timer.vue";
import ImageCard from "@/components/ImageCard";
import GeneralService from "@/services/GeneralService";
import { mapState } from 'vuex';

export default {
    props: [ 'registrationObj', 'title' ],
    data() {
      return {
        errorImage: require("@/assets/images/partPlaceholder.jpg"),
        months : ["Jan", "Feb", "Mar","Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
      };
    },
    components: {
        VRow, VCol, VTextField, Timer, ImageCard
    },
    computed: {
      ...mapState({
        urlDomain: (state) =>state.env.get('VUE_APP_ROOT'),
        defaultPromoterId: state => {
          const defaultPromoterIds = state.env.get('VUE_APP_DEFAULT_PROMOTER');
          return defaultPromoterIds && defaultPromoterIds.length > 0 ? defaultPromoterIds.split(',').filter(el => !!el).map(id => parseInt(id)) : [];
        },
        defaultRegistration: state => state.env.get('VUE_APP_DEFAULT_REGISTRATION'),
        promoterDefault: (state) => {
          return state.registerEvent.promoterSelData;
        },
        url_image: "vueAppLogoView"
      }),
      promoterName() {
        if(
          Array.isArray(this.defaultPromoterId) && this.defaultPromoterId.length == 1 && this.promoterDefault
        ) {
          return this.promoterDefault.promoterLinkName;
        }
        return this.registrationObj.promoterSel.promoterLinkName;
      },
      VUE_APP_ENV: () => process.env.VUE_APP_USE_ENV,
      isStrapi() {
        return this.VUE_APP_ENV == '0';
      },
      url_image_processed() {
        return this.isStrapi ? this.url_image : require('@/assets/images/VectorLogo.png');
      }

    },
    methods: {
      loadImage(url) {
        const urlImage = GeneralService.cleanImage(url, this.$store.getters.env.get('VUE_APP_IMAGE_PLACEHOLDER'));
        return urlImage;
      },
      changeType() {
        if(this.registrationObj.eventSel.type == 'soon') {
          this.registrationObj.eventSel.type = 'now';
        }
      },
      loadPlaceholder(e) {
        e.target.src = this.errorImage;
      },
      loadDefaultPromoter() {}
    },
    mounted() {
      this.loadDefaultPromoter();
    }
};
</script>

<style>
@media(max-width: 400px) {
  #cont_steps .input_str_2 .v-input__control {
    display: block;
  }
  #cont_steps .input_str_2 .v-text-field__details {
    white-space: nowrap;
  }
}
.timer_column .timer_container {
  width: 100%;
}
</style>
